import React from "react";
import Link from "next/link";

interface ProductCardHeaderProps {
  text: string;
  viewAllLink?: string;
  category?: string;
  isLink?: boolean;
  showArrow?: boolean;
}

function ProductCardHeader({
  text,
  viewAllLink = "/products",
  category,
  isLink = false,
  showArrow = false,
}: ProductCardHeaderProps) {
  const href = category ? `${viewAllLink}?category=${encodeURIComponent(category)}` : viewAllLink;

  const HeaderContent = () => (
    <h2 className="text-lg font-bold text-gray-900 flex items-center gap-1">
      {text}
      {showArrow && <span className="cursor-pointer text-lg">&gt;</span>}
    </h2>
  );

  if (isLink) {
    return (
      <div className="w-full flex items-center mb-6 px-4">
        <Link href={href} className="relative inline-flex items-center group">
          <HeaderContent />
          <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-yellow-500 transform origin-left transition-transform duration-300 group-hover:scale-x-110"></span>
        </Link>
      </div>
    );
  }

  return (
    <div className="w-full flex items-center mb-6 px-4">
      <div className="relative inline-flex items-center">
        <HeaderContent />
        <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-yellow-500"></span>
      </div>
    </div>
  );
}

export default ProductCardHeader;
